// src/components/Footer.jsx
import React from "react";

const Footer = ({ currentPage }) => {
  const isHomePage = currentPage === "home";

  return (
    <footer
      className={
        isHomePage
          ? "bg-black/40 backdrop-blur-sm text-white py-12 border-t border-white/20"
          : "bg-gray-800 text-white py-12"
      }
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          {/* 左侧：Logo + 简介 */}
          <div className="text-center md:text-left max-w-lg">
            <div className="flex items-center justify-center md:justify-start space-x-3 mb-4">
              <div className="w-12 h-12 bg-gradient-to-r from-blue-600 via-purple-600 to-emerald-600 rounded-2xl flex items-center justify-center">
                <span className="text-white font-bold text-xl">西</span>
              </div>
              <h3 className="text-xl font-bold">西航投（云南）新能源有限公司</h3>
            </div>
            <p className={`text-sm ${isHomePage ? "text-blue-200" : "text-gray-400"} mb-4`}>
              注册资本3.986亿元，专注于储能、风电、光伏等新能源项目的投资、建设与运营。
            </p>
          </div>

          {/* 右侧：联系方式 */}
          <div className={`space-y-3 text-center md:text-left ${isHomePage ? "text-blue-200" : "text-gray-400"}`}>
            <div className="flex flex-col sm:flex-row sm:items-center gap-2 justify-center md:justify-start">
              <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span className="text-sm">云南省昆明市西山区西苑街道秋苑二期2组团22幢2单元403号</span>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center gap-2 justify-center md:justify-start">
              <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <span className="text-sm">452081898@qq.com</span>
            </div>
          </div>
        </div>

        {/* 底部版权 */}
        <div className={`mt-12 pt-6 border-t ${isHomePage ? "border-white/20 text-blue-200" : "border-gray-700 text-gray-400"} text-center`}>
          <p className="text-sm">
            &copy; 2025 西航投（云南）新能源有限公司 版权所有 
          </p>
          <p className="text-xs mt-1 opacity-80">
            本网站内容归西航投（云南）新能源有限公司所有，未经许可不得转载
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;